import React from 'react';
import './DefaultHomepage.css'


function DefaultHomepage() {
 return (
  <div className="default-homepage">
   <section className="hero">

   </section>

   <section className="about">
   
   </section>

   <section id="schedule" className="schedule-preview">
   
   </section>

  </div>
 );
}

export default DefaultHomepage;
